<div *ngIf="comment" style="position: relative;">
    <div class="background-hover" [class.overlay-danger]="comment.numReports > 0 && !comment.deleted && comment.inappropriate == null" [style.opacity]="comment.deleted || comment.inappropriate ? 0.5 : 1.0">
        <div>
            <div class="float-start">
                <img src="{{ comment.user.avatar }}" width="64px" height="64px" class="border rounded-circle align-top">
                <div class="d-inline-block">
                    <div>
                        <code><a routerLink="/users/{{ comment.user.id }}">#{{ comment.user.id }}</a></code>
                    </div>
                    <div>
                        <strong>{{ comment.user.name }}</strong>
                    </div>
                    <div [class.text-muted]="!comment.user.banned" [class.text-danger]="comment.user.banned" style="line-height: 1; cursor: pointer;" (click)="updateUserBanned(!comment.user.banned)">
                        <small [class.font-weight-normal]="!comment.user.banned" [class.font-weight-bold]="comment.user.banned">banned</small>&nbsp;<i class="fas align-middle" [class.fa-toggle-off]="!comment.user.banned" [class.fa-toggle-on]="comment.user.banned"></i>
                    </div>
                </div>
            </div>
            <div class="float-end text-end">
                <div>
                    <code><a routerLink="/community/comments/{{ comment.id }}">#{{ comment.id }}</a></code>
                </div>
                <div>
                    <div class="form-check form-check-inline d-inline-flex align-items-center m-0 ps-1">
                        <label class="form-check-label" [class.text-danger]="comment.deleted" [class.font-weight-bold]="comment.deleted" for="commentDeletedControl_{{ comment.id }}">deleted</label>
                        <select id="commentDeletedControl_{{ comment.id }}" class="form-select form-select-sm" #commentDeletedControl (change)="commentDeletedControlChange(commentDeletedControl.value)">
                            <option value="false" [selected]="!comment.deleted">No</option>
                            <option value="true" [selected]="comment.deleted">Yes</option>
                        </select>
                    </div>
                    <div class="form-check form-check-inline d-inline-flex align-items-center m-0 ps-1">
                        <label class="form-check-label" [class.text-danger]="comment.inappropriate != null && comment.inappropriate" [class.font-weight-bold]="comment.inappropriate != null && comment.inappropriate" for="commentInappropriateControl_{{ comment.id }}">inappropriate</label>
                        <select id="commentInappropriateControl_{{ comment.id }}" class="form-select form-select-sm" #commentInappropriateControl (change)="commentInappropriateControlChange(commentInappropriateControl.value)">
                            <option value="undefined" [selected]="comment.inappropriate == null">―</option>
                            <option value="false" [selected]="comment.inappropriate != null && !comment.inappropriate">No</option>
                            <option value="true" [selected]="comment.inappropriate != null && comment.inappropriate">Yes</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="mb-2">
            <div class="float-start">
                <small class="text-muted"></small>
            </div>
            <div class="float-end text-end">
                <small class="text-muted">{{ comment.datetime | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}</small>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="mb-2">
            <blockquote class="blockquote m-0">“ {{ comment.text }} ”</blockquote>
        </div>
        <div class="mb-2">
            <div class="row">
                <div class="col-auto">
                    <button class="btn btn-sm fnt-sm btn-info text-light" style="pointer-events: none;">
                        <i class="fas fa-bullhorn"></i> Reports
                        <span class="badge bg-light text-dark">{{ comment.numReports }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>